window.PONS.research = [
 {
  "product": "signal",
  "slug": "citicoline",
  "name": "Citicoline",
  "dose": "250 mg a day",
  "why": "Studied at 250-500 mg/day for 28 days to 12 weeks in healthy adolescents and older adults; researchers measured attention and memory test scores.",
  "claim": "",
  "studies": [
   {
    "title": "Citicoline and Memory Function in Healthy Older Adults: A Randomized, Double-Blind, Placebo-Controlled Clinical Trial",
    "url": "https://pubmed.ncbi.nlm.nih.gov/33978188/",
    "cite": "Nakazaki E et al.. The Journal of Nutrition, 2021. PMID 33978188.",
    "design": "Randomised, double-blind, placebo-controlled trial. n=100 healthy adults aged 50-85 years with age-associated memory impairment (49 citicoline, 51 placebo). 12 weeks.",
    "dose": "Citicoline (Cognizin) 500 mg/day, oral",
    "found": "The authors reported greater improvement with citicoline than placebo on the episodic memory test and the composite memory score, with no safety concerns.",
    "note": "Study used 500 mg/day; PONS provides 250 mg/day, i.e. half the studied dose."
   },
   {
    "title": "The Effect of Citicoline Supplementation on Motor Speed and Attention in Adolescent Males",
    "url": "https://pubmed.ncbi.nlm.nih.gov/26179181/",
    "cite": "McGlade E et al.. Journal of Attention Disorders, 2019. PMID 26179181.",
    "design": "Randomised, placebo-controlled trial. n=75 healthy adolescent males (51 citicoline, 24 placebo). 28 days.",
    "dose": "Citicoline 250 mg/day or 500 mg/day, oral",
    "found": "The authors reported better attention and faster psychomotor speed in the citicoline group than placebo, with higher weight-adjusted doses associated with better accuracy and lower impulsivity.",
    "note": "One study arm used exactly 250 mg/day, matching the PONS dose; population was adolescent males, not adults."
   }
  ]
 },
 {
  "product": "signal",
  "slug": "acetyl-l-carnitine",
  "name": "Acetyl-L-carnitine",
  "dose": "500 mg a day",
  "why": "Studied in adults over 70 with chronic fatigue; researchers measured fatigue scales, functional status and a cognitive screening score.",
  "claim": "",
  "studies": [
   {
    "title": "Acetyl L-carnitine (ALC) treatment in elderly patients with fatigue",
    "url": "https://pubmed.ncbi.nlm.nih.gov/17658628/",
    "cite": "Malaguarnera M et al.. Archives of Gerontology and Geriatrics, 2008. PMID 17658628.",
    "design": "Randomised, double-blind controlled trial. n=96 adults aged 71-88 years (50 women, 46 men) meeting criteria for chronic fatigue. Not stated in the abstract.",
    "dose": "Acetyl-L-carnitine, oral; the abstract does not state the daily dose",
    "found": "The authors reported larger reductions in physical fatigue, mental fatigue and Fatigue Severity Scale scores, and larger improvements in functional status and MMSE, with ALC than with control.",
    "note": "Dose not stated in the abstract; ALCAR trials in older adults typically use 1.5-3 g/day, so PONS 500 mg/day is well below the usual studied range."
   }
  ]
 },
 {
  "product": "signal",
  "slug": "l-tyrosine",
  "name": "L-tyrosine",
  "dose": "500 mg a day",
  "why": "Studied at 2 g/day for one week in military cadets under a demanding training course; researchers measured memory and tracking tasks and blood pressure.",
  "claim": "",
  "studies": [
   {
    "title": "Tyrosine improves cognitive performance and reduces blood pressure in cadets after one week of a combat training course",
    "url": "https://pubmed.ncbi.nlm.nih.gov/10230711/",
    "cite": "Deijen JB et al.. Brain Research Bulletin, 1999. PMID 10230711.",
    "design": "Randomised controlled trial (two parallel supplement groups). n=21 cadets on a demanding military combat training course (10 tyrosine, 11 control). Five daily doses across the first six days of the course.",
    "dose": "Protein-rich drink containing 2 g tyrosine per day in five daily doses, versus an isocaloric carbohydrate-rich drink (255 kcal)",
    "found": "The authors reported better memory and tracking task performance and lower systolic blood pressure in the tyrosine group, with no effect on mood.",
    "note": "Study used 2 g/day, four times the PONS dose of 500 mg/day; population was cadets under acute physical stress, not resting healthy adults."
   },
   {
    "title": "Working Memory Reloaded: Tyrosine Repletes Updating in the N-Back Task",
    "url": "https://www.frontiersin.org/journals/behavioral-neuroscience/articles/10.3389/fnbeh.2013.00200/full",
    "cite": "Colzato LS, Jongkees BJ, Sellaro R, Hommel B. Frontiers in Behavioral Neuroscience, 2013.",
    "design": "Randomised, double-blind, placebo-controlled crossover trial. n=22 healthy female undergraduates, mean age 19.7 years (range 18-25). Acute: testing began about one hour after dosing, two sessions 3-7 days apart.",
    "dose": "Single acute dose of 2.0 g L-tyrosine powder in 400 ml orange juice, versus 2.0 g microcrystalline cellulose placebo",
    "found": "The authors reported no measurable effect on the 1-back task but higher accuracy (86.5% to 91.4%) and fewer false alarms (10.9% to 6.7%) with tyrosine on the harder 2-back task, with no changes in heart rate, blood pressure or mood.",
    "note": "Study used a single 2 g dose, four times the PONS daily dose of 500 mg; acute single-dose design, healthy young women only."
   }
  ]
 },
 {
  "product": "signal",
  "slug": "bacopa-monnieri",
  "name": "Bacopa monnieri",
  "dose": "300 mg a day",
  "why": "Studied at 300 mg/day for 12 weeks in healthy adults; researchers measured information-processing speed, verbal learning and state anxiety.",
  "claim": "",
  "studies": [
   {
    "title": "The chronic effects of an extract of Bacopa monniera (Brahmi) on cognitive function in healthy human subjects",
    "url": "https://pubmed.ncbi.nlm.nih.gov/11498727/",
    "cite": "Stough C et al.. Psychopharmacology, 2001. PMID 11498727.",
    "design": "Randomised, double-blind, placebo-controlled trial with independent groups. Healthy adults; sample size and age range not given in the retrieved record. 12 weeks, with testing at baseline, 5 weeks and 12 weeks.",
    "dose": "Bacopa monnieri extract (Keenmind) 300 mg versus placebo",
    "found": "The authors reported improvements versus placebo in information-processing speed, learning rate, memory consolidation and state anxiety, largest at 12 weeks.",
    "note": "Study used 300 mg/day, matching the PONS dose exactly; bacoside standardisation of the study extract was not stated in the record. A 2015 erratum notes a dosage error in the article text; we are checking the 300 mg figure against the full paper."
   },
   {
    "title": "Effects of a standardized Bacopa monnieri extract on cognitive performance, anxiety, and depression in the elderly: a randomized, double-blind, placebo-controlled trial",
    "url": "https://pubmed.ncbi.nlm.nih.gov/18611150/",
    "cite": "Calabrese C et al.. Journal of Alternative and Complementary Medicine, 2008. PMID 18611150.",
    "design": "Randomised, double-blind, placebo-controlled trial with a 6-week placebo run-in. n=54 enrolled, 48 completed (24 per group); community volunteers aged 65+ (mean about 73.5 years) without signs of dementia. 12 weeks of treatment.",
    "dose": "Standardised whole-plant dry extract of Bacopa monnieri, 300 mg/day in oral tablets, versus matching placebo",
    "found": "The authors reported improvement in the Bacopa group on delayed word recall and the Stroop task after adjusting for baseline cognitive deficit, with decreases in depression and anxiety scores and heart rate, and no effects on divided attention, digit tasks, mood profile or blood pressure.",
    "note": "Study used 300 mg/day, matching the PONS dose exactly; population was adults aged 65+."
   },
   {
    "title": "Meta-analysis of randomized controlled trials on cognitive effects of Bacopa monnieri extract",
    "url": "https://pubmed.ncbi.nlm.nih.gov/24252493/",
    "cite": "Kongkeaw C et al.. Journal of Ethnopharmacology, 2014. PMID 24252493.",
    "design": "Systematic review and meta-analysis of randomised placebo-controlled trials. 9 studies, 518 participants in total, 437 included in the meta-analysis. Chronic dosing of at least 12 weeks.",
    "dose": "Standardised Bacopa monnieri extracts without co-medication; specific doses not stated in the abstract",
    "found": "The authors reported a shorter Trail B time of about 17.9 ms (95% CI -24.6 to -11.2; p<0.001) and a change in choice reaction time, and concluded that Bacopa may affect speed of attention.",
    "note": "Pooled doses not stated in the abstract; included trials commonly use 300 mg/day, the PONS dose, and the 12-week minimum duration matches typical Bacopa dosing."
   }
  ]
 },
 {
  "product": "signal",
  "slug": "l-theanine",
  "name": "L-theanine",
  "dose": "200 mg a day",
  "why": "Studied at 200 mg/day for four weeks in healthy adults; researchers measured sleep, mood and anxiety questionnaires and cognitive test batteries.",
  "claim": "",
  "studies": [
   {
    "title": "Effects of L-Theanine Administration on Stress-Related Symptoms and Cognitive Functions in Healthy Adults: A Randomized Controlled Trial",
    "url": "https://pubmed.ncbi.nlm.nih.gov/31623400/",
    "cite": "Hidese S et al.. Nutrients, 2019. PMID 31623400.",
    "design": "Randomised, double-blind, placebo-controlled crossover trial with a two-week washout. n=30 healthy adults without major psychiatric illness (9 men, 21 women; mean age 48.3 years, range 20-69). Four weeks per treatment period.",
    "dose": "L-theanine 200 mg/day as oral tablets, taken before sleep, versus matching placebo",
    "found": "The authors reported lower depression, trait anxiety and sleep-quality-index scores after L-theanine, reduced PSQI subscales for sleep latency, disturbance and medication use versus placebo, and improved verbal fluency and executive function scores after L-theanine.",
    "note": "Study used 200 mg/day, matching the PONS dose exactly, in healthy adults. the full text reports that the overall between-group cognitive comparison was not significant and that the verbal-fluency finding came from a baseline-stratified subgroup analysis; the study was funded by the ingredient supplier."
   },
   {
    "title": "Acute effects of theanine, caffeine and theanine-caffeine combination on attention",
    "url": "https://pubmed.ncbi.nlm.nih.gov/26869148/",
    "cite": "Kahathuduwa CN et al.. Nutritional Neuroscience, 2017. PMID 26869148.",
    "design": "Placebo-controlled, five-way crossover trial. n=20 healthy male volunteers. Acute single doses.",
    "dose": "L-theanine 200 mg; caffeine 160 mg; theanine plus caffeine; one cup of black tea; distilled water placebo",
    "found": "The authors reported improved recognition visual reaction time with theanine (p=0.019), caffeine (p=0.043) and the combination (p=0.001), and increased N2-P300 amplitude with theanine and caffeine versus placebo, with no significant theanine-caffeine interaction.",
    "note": "Study used 200 mg, matching the PONS dose exactly, but as a single acute dose in healthy men only."
   }
  ]
 },
 {
  "product": "signal",
  "slug": "lion-s-mane",
  "name": "Lion's mane",
  "dose": "250 mg a day",
  "why": "Studied at 1.8 g/day for 28 days in healthy adults aged 18-45; researchers measured Stroop task speed, mood and subjective stress.",
  "claim": "",
  "studies": [
   {
    "title": "The Acute and Chronic Effects of Lion's Mane Mushroom Supplementation on Cognitive Function, Stress and Mood in Young Adults: A Double-Blind, Parallel Groups, Pilot Study",
    "url": "https://pubmed.ncbi.nlm.nih.gov/38004235/",
    "cite": "Docherty S et al.. Nutrients, 2023. PMID 38004235.",
    "design": "Randomised, double-blind, placebo-controlled, parallel-groups pilot study. n=41 healthy adults aged 18-45 years. Acute (60 minutes post-dose) and 28 days.",
    "dose": "Hericium erinaceus 1.8 g/day (single 1.8 g dose for the acute phase); product form not specified in the abstract",
    "found": "The authors reported faster Stroop task completion 60 minutes after a single dose (p=0.005) and a non-significant trend toward lower subjective stress after 28 days (p=0.051), cautioning that the small sample needs confirmation in larger studies.",
    "note": "Study used 1.8 g/day, about 7x the PONS 250 mg/day; it is also unclear from the abstract whether fruiting body or mycelium was used."
   }
  ]
 },
 {
  "product": "source",
  "slug": "magnesium",
  "name": "Magnesium",
  "dose": "250 mg elemental magnesium a day",
  "why": "Pooled across 34 randomised trials at a median 368 mg/day for about three months.",
  "claim": "Authorised EU claims include: contributes to a reduction of tiredness and fatigue, and to electrolyte balance.",
  "studies": [
   {
    "title": "Effects of Magnesium Supplementation on Blood Pressure: A Meta-Analysis of Randomized Double-Blind Placebo-Controlled Trials",
    "url": "https://pubmed.ncbi.nlm.nih.gov/27402922/",
    "cite": "Zhang X et al.. Hypertension, 2016. PMID 27402922.",
    "design": "Meta-analysis of randomised, double-blind, placebo-controlled trials. 34 trials, 2,028 normotensive and hypertensive adults. Median 3 months.",
    "dose": "Oral magnesium supplements, median dose 368 mg/day (forms varied across trials)",
    "found": "The authors reported that magnesium lowered systolic blood pressure by 2.00 mm Hg (95% CI 0.43-3.58) and diastolic by 1.78 mm Hg (95% CI 0.73-2.82) versus placebo, and raised serum magnesium by 0.05 mmol/L, with spline analysis suggesting 300 mg/day for one month was sufficient.",
    "note": "Median studied dose 368 mg/day; PONS provides 250 mg/day, about two-thirds of that and below the 300 mg/day threshold the authors identified in their spline analysis."
   }
  ]
 },
 {
  "product": "source",
  "slug": "potassium",
  "name": "Potassium",
  "dose": "400 mg a day",
  "why": "Pooled across 22 randomised trials and 11 cohorts.",
  "claim": "Authorised EU claim: contributes to the maintenance of normal blood pressure.",
  "studies": [
   {
    "title": "Effect of increased potassium intake on cardiovascular risk factors and disease: systematic review and meta-analyses",
    "url": "https://pubmed.ncbi.nlm.nih.gov/23558164/",
    "cite": "Aburto NJ et al.. BMJ, 2013. PMID 23558164.",
    "design": "Systematic review and meta-analyses of randomised controlled trials and cohort studies. 22 RCTs (1,606 participants) for risk factors; 11 cohort studies (127,038 participants) for clinical outcomes; adults, plus a small set of paediatric studies. Varied across included trials.",
    "dose": "Increased potassium intake, including potassium salt supplementation; subgroup analysed intakes of 90-120 mmol/day (about 3,500-4,700 mg/day)",
    "found": "The authors reported that higher potassium intake lowered systolic blood pressure by 3.49 mm Hg and diastolic by 1.96 mm Hg (effect seen in people with hypertension but not those without), was associated with 24% lower stroke risk, and had no adverse effect on renal function, lipids or catecholamines in adults.",
    "note": "Trials studied intakes far above the PONS dose: the subgroup with the largest effect used 90-120 mmol/day (about 3,500-4,700 mg/day) versus PONS 400 mg/day. PONS 400 mg is a partial contribution to total daily intake, not a therapeutic dose."
   }
  ]
 },
 {
  "product": "source",
  "slug": "sodium",
  "name": "Sodium",
  "dose": "300 mg sodium a day",
  "why": "Studied in healthy active men drinking 1 L beverages of 7-52 mmol/L sodium; researchers measured urine output and net fluid balance over four hours.",
  "claim": "Sodium has no authorised health claim and no NRV.",
  "studies": [
   {
    "title": "Sucrose and Sodium but not Caffeine Content Influence the Retention of Beverages in Humans Under Euhydrated Conditions",
    "url": "https://pubmed.ncbi.nlm.nih.gov/29893590/",
    "cite": "Maughan RJ, Watson P, Cordery PAA, Walsh NP, Oliver SJ, Dolci A, Rodriguez-Sanchez N, Galloway SDR. International Journal of Sport Nutrition and Exercise Metabolism, 2019. PMID 29893590.",
    "design": "Double-blind crossover trials (three cohorts, one per beverage component). 36 young healthy active men in three cohorts of 12. Acute: 4 hours of urine collection after each 1 L drink.",
    "dose": "1 L beverages containing sodium at 7, 15, 27 or 52 mmol/L (about 160-1,200 mg sodium per litre); parallel sucrose and caffeine arms",
    "found": "The authors reported lower cumulative urine output and higher net fluid balance after beverages containing 27 and 52 mmol/L sodium than after 7 and 15 mmol/L (p<0.05), with no effect of caffeine and no differences in vasopressin or aldosterone.",
    "note": "The higher-retention beverages delivered roughly 620-1,200 mg sodium per litre; PONS provides 300 mg sodium per daily serving, which is at or below the lower-sodium conditions in this trial if taken in about 0.5-1 L of fluid."
   }
  ]
 },
 {
  "product": "source",
  "slug": "zinc",
  "name": "Zinc",
  "dose": "6.5 mg a day",
  "why": "Pooled across 95 human studies using 0.09-150 mg zinc per day; researchers measured plasma/serum zinc and other candidate status biomarkers.",
  "claim": "Authorised EU claim: contributes to normal cognitive function.",
  "studies": [
   {
    "title": "Methods of Assessment of Zinc Status in Humans: An Updated Review and Meta-analysis",
    "url": "https://pubmed.ncbi.nlm.nih.gov/38917458/",
    "cite": "Ceballos-Rasgado M et al.. Nutrition Reviews, 2024. PMID 38917458.",
    "design": "Systematic review and meta-analysis of randomised controlled trials, controlled clinical trials and before-and-after studies (PROSPERO CRD42020219843). 95 studies from 99 articles; 82 studies in the plasma/serum zinc meta-analysis (for example 48 controlled trials with 4,316 participants in healthy participants). 1.8 to 104.2 weeks across included studies.",
    "dose": "0.09-150 mg elemental zinc/day as zinc sulfate, gluconate or acetate; depletion studies also included",
    "found": "The authors reported that plasma/serum zinc responded to changes in zinc intake in healthy participants, with a mean effect of 2.17 micromol/L (95% CI 1.73-2.61) in controlled trials, while noting very high heterogeneity (I-squared above 97%).",
    "note": "The PONS dose of 10 mg/day sits inside the 0.09-150 mg/day range covered by the review; no single dose-matched arm is isolated here."
   }
  ]
 },
 {
  "product": "source",
  "slug": "selenium",
  "name": "Selenium",
  "dose": "40 mcg a day",
  "why": "Studied at 50, 100 and 200 mcg/day for 12 weeks in UK adults aged 50-64; researchers measured plasma selenium and selenoprotein P.",
  "claim": "Authorised EU claim: contributes to the protection of cells from oxidative stress.",
  "studies": [
   {
    "title": "Establishing optimal selenium status: results of a randomized, double-blind, placebo-controlled trial",
    "url": "https://pubmed.ncbi.nlm.nih.gov/20181815/",
    "cite": "Hurst R et al.. The American Journal of Clinical Nutrition, 2010. PMID 20181815.",
    "design": "Randomised, double-blind, placebo-controlled parallel trial. n=119 enrolled (117 analysed) healthy UK men and women aged 50-64 with plasma selenium below 110 ng/mL. 12 weeks, with blood sampling at weeks 0, 6 and 10.",
    "dose": "Selenium-enriched yeast tablets at 50, 100 or 200 mcg Se/day (about 60% selenomethionine); selenium-enriched onion meals equivalent to 50 mcg Se/day; unenriched onion; placebo",
    "found": "The authors reported dose-related rises in plasma selenium (to 118.3, 152.0 and 177.4 ng/mL at 50, 100 and 200 mcg/day) and significant rises in selenoprotein P in all selenium groups, with no significant change in platelet glutathione peroxidase, concluding that about 50 mcg/day on top of a habitual 55 mcg/day optimised selenoprotein P.",
    "note": "The lowest study arm, 50 mcg/day, is very close to the PONS 55 mcg/day; participants had suboptimal baseline selenium status."
   }
  ]
 },
 {
  "product": "source",
  "slug": "copper",
  "name": "Copper",
  "dose": "1 mg a day",
  "why": "Studied at 3 mg and 6 mg supplemental copper per day for six weeks in healthy young adults; researchers measured DNA damage and liver enzymes.",
  "claim": "Authorised EU claim: contributes to normal energy-yielding metabolism.",
  "studies": [
   {
    "title": "Copper Supplementation Has No Effect on Markers of DNA Damage and Liver Function in Healthy Adults (FOODCUE Project)",
    "url": "https://pubmed.ncbi.nlm.nih.gov/12748413/",
    "cite": "O'Connor JM, Bonham MP, Turley E, McKeown A, McKelvey-Martin VJ, Gilmore WS, Strain JJ. Annals of Nutrition and Metabolism, 2003. PMID 12748413.",
    "design": "Double-blind, repeated crossover trial with placebo periods between treatment periods. Healthy young free-living men and women; the number of participants is not stated in the retrieved abstract. Six weeks per supplementation period.",
    "dose": "Copper sulfate at 3 mg Cu/day, then copper amino acid chelate at 3 mg/day and 6 mg/day, oral",
    "found": "The authors reported no significant change in DNA damage or liver function at either dose, concluding that copper intakes up to a total of about 7 mg/day did not induce DNA damage or adversely affect liver function in healthy adults.",
    "note": "Study used 3-6 mg supplemental copper/day, 3-6x the PONS 1 mg/day; it supports tolerability at intakes well above the PONS dose rather than efficacy at 1 mg."
   }
  ]
 }
];
